var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import './QuickTableRow.css';
export default function QuickTableRow(_a) {
    var row = _a.row, headers = _a.headers, defaultWidth = _a.defaultWidth, cellStyle = _a.cellStyle, rowStyle = _a.rowStyle, className = _a.className, index = _a.index;
    var appliedRowStyle = rowStyle(row);
    return (_jsx("div", __assign({ className: 'QuickTableRow ' + className, style: appliedRowStyle }, { children: Object.keys(headers).map(function (h) {
            var wd = headers[h].width || defaultWidth;
            var cellContents;
            var Comp = headers[h].component;
            if (Comp) {
                cellContents = _jsx(Comp, __assign({ row: row, cell: row[h], headers: headers, headerID: h, index: index }, headers[h].props), h);
            }
            else {
                cellContents = row[h];
            }
            var formatter = headers[h].format;
            if (formatter) {
                cellContents = formatter(row[h], row);
            }
            var styler = headers[h].cellStyle;
            var appliedStyle = styler ? styler(row[h], row) : {};
            appliedStyle = __assign(__assign({}, appliedStyle), cellStyle(row[h], row));
            return _jsx("span", __assign({ className: "cellContainer", style: { width: wd } }, { children: _jsx("span", __assign({ className: "cell", style: appliedStyle }, { children: cellContents }), void 0) }), h);
        }) }), void 0));
}
//# sourceMappingURL=QuickTableRow.js.map